import React, { useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "components/ui/button";
import QuestionForm from "./QuestionForm";
import { CustomQuestion } from "./CallScriptManager";

interface CustomQuestionsPanelProps {
  onAdd: (question: Omit<CustomQuestion, "id">) => void;
}

const CustomQuestionsPanel: React.FC<CustomQuestionsPanelProps> = ({
  onAdd,
}) => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const handleAddClick = () => {
    setIsFormOpen(true);
  };

  const handleFormSave = (questionData: Omit<CustomQuestion, "id">) => {
    onAdd(questionData);
    setIsFormOpen(false);
  };

  const handleFormClose = () => {
    setIsFormOpen(false);
  };

  return (
    <div className="space-y-4">
      {/* Add Button */}
      <Button
        variant="outline"
        className="w-full"
        onClick={handleAddClick}
      >
        <Plus className="h-4 w-4 mr-2" />
        Add Custom Question
      </Button>

      {/* Info Message */}
      <div className="text-center py-8">
        <div className="p-4 bg-gray-100 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
          <Plus className="h-8 w-8 text-gray-400" />
        </div>
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          Create Custom Questions
        </h3>
        <p className="text-gray-600 mb-6 max-w-md mx-auto">
          Create custom questions for your call script. Once created, they will appear in the Question Order panel where you can reorder them.
        </p>
      </div>

      {/* Question Form Dialog */}
      <QuestionForm
        open={isFormOpen}
        onOpenChange={handleFormClose}
        question={null}
        onSave={handleFormSave}
      />
    </div>
  );
};

export default CustomQuestionsPanel;
